var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _tspan, _tspan2, _tspan3, _tspan4, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapemyhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510 232",
    width: 510,
    height: 232,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SHAPE MY HOUSE FINAL LOGO 12 final") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #cca605 } \n\t\t.s1 { fill: #9f8067 } \n\t\t.s2 { fill: #fcfcfc } \n\t\t.t3 { font-size: 39px;fill: #9f8067;font-weight: 500;font-family: \"Poppins-Medium\", \"Poppins\" } \n\t\t.t4 { font-size: 39px;fill: #f7edc4;font-weight: 500;font-family: \"Poppins-Medium\", \"Poppins\" } \n\t\t.t5 { font-size: 39px;fill: #cca605;font-weight: 500;font-family: \"Poppins-Medium\", \"Poppins\" } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m180.7 117.5h52.5v47.5h-52.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m286.8 116.3h52.5v47.5h-52.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m232.5 117.5h54l-25.4 20.6-28.6-20.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m182 2.2v53.8h56.8l-56.8-53.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m338 7.6v48.4h-56.8l56.8-48.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m363.4 12.8h51.4v44.4h-51.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m439.4 13h51.4v44.4h-51.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m439.4 119.1h51.4v44.4h-51.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m363.4 119.1h51.4v44.4h-51.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m332 109.9c-11.3 0.3-29.7 0.6-41 0.9l-12.1-11.9-37.9 0.4-13.8 12.7h-45.2c-2.9-34.4-0.6-50-0.6-50 0 0 45.5 2.1 302.6 2.7q13.5 11.1 27 22.3c-7.3 8.3-18.7 16.7-26 25l-26-0.3-14-11.8h-29l-5 11.8h-40l-9-11.8c-3.3 0 3.2 0 0 0-10 0-13.1 0.1-23 0.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s2",
    d: "m180.5 73.1h292.8v8.1h-292.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m41.8 108.7c0 0-37.8 4.3-37.8-46.7h120.3c0 0 38.7 17.2 38.7 46.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "SHAPE",
    style: {
      transform: "matrix(1.2,0,0,1,62.91,231.42)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "SHAPE\n"))), /*#__PURE__*/React.createElement("text", {
    id: " ",
    style: {
      transform: "matrix(1.2,0,0,1,208.386,231.42)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t4"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "MY ",
    style: {
      transform: "matrix(1.2,0,0,1,220.494,231.42)"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t5"
  }, "MY \n"))), /*#__PURE__*/React.createElement("text", {
    id: "HOUSE",
    style: {
      transform: "matrix(1.2,0,0,1,301.83,231.42)"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "HOUSE\n")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m10.5 0h145c5.8 0 10.5 4.7 10.5 10.5v33c0 5.8-4.7 10.5-10.5 10.5h-145c-5.8 0-10.5-4.7-10.5-10.5v-33c0-5.8 4.7-10.5 10.5-10.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m10.5 117h145c5.8 0 10.5 4.7 10.5 10.5v27c0 5.8-4.7 10.5-10.5 10.5h-145c-5.8 0-10.5-4.7-10.5-10.5v-27c0-5.8 4.7-10.5 10.5-10.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s2",
    d: "m36 96c-6.6 0-12-5.4-12-12 0-6.6 5.4-12 12-12 6.6 0 12 5.4 12 12 0 6.6-5.4 12-12 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapemyhouse);
export default __webpack_public_path__ + "static/media/SHAPEMYHOUSE.39d11071a395b881ef095b3f8d0de759.svg";
export { ForwardRef as ReactComponent };